interface Props {
  reportURL: string;
}

export const Reports = ({ reportURL }: Props) => {
  return <iframe src={reportURL} width={'100%'} height={'100%'} style={{ border: 0 }}></iframe>;
};
